import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

const NAV_MAP = {
  "Enhanced Insights": "enhancedPage",
  "Rep Performance": "repPage",
  "Other Insights": "othersPage",
  "Marketing Support Requests": "marketPage",
  "Growth Modeling": "growthModelingPage",
  "Pipeline Build & Sufficiency": "pipelineBuildandSuficencyPage",
  "Pipeline Velocity & Conversion": "pipelineVelocityandConversionPage",
  "Market Intel & Growth Levers": "marketIntelandGrowthLeversPage",
  "Sales Productivity": "salesProductivityPage",
  "Growth Science Insights": "growthScienceInsightsPage",
  "Custom Scorecards": "personalizedScorecardsPage",
  "Settings": "SettingsPage",
  "Product Performance": "productPage",
};

const RccDeepLinkComponent = () => {
  const history = useHistory();
  const user = useSelector((state) => state.app?.user);

  useEffect(() => {
    const elements = user?.elements || [];
    const groupObj = elements.find(
      (g) =>
        g?.charts &&
        g.charts.some((c) => c?.Chart_Name === "Revenue Command Center"),
    );
    const rccGroup = groupObj?.navItem;

    if (rccGroup === "Home") {
      localStorage.setItem("skygeni-user-page", "Home");
      Object.values(NAV_MAP).forEach((key) => {
        localStorage.removeItem(`skygeni-user-${key}`);
      });
    } else if (rccGroup && NAV_MAP[rccGroup]) {
      localStorage.setItem("skygeni-user-page", rccGroup);
      localStorage.setItem(
        `skygeni-user-${NAV_MAP[rccGroup]}`,
        "Revenue Command Center",
      );
      const targetKey = NAV_MAP[rccGroup];
      Object.values(NAV_MAP).forEach((key) => {
        if (key !== targetKey) {
          localStorage.removeItem(`skygeni-user-${key}`);
        }
      });
    } else {
      localStorage.setItem("skygeni-user-page", "Other Insights");
      localStorage.setItem(
        "skygeni-user-othersPage",
        "Revenue Command Center",
      );
      Object.values(NAV_MAP).forEach((key) => {
        if (key !== "othersPage") {
          localStorage.removeItem(`skygeni-user-${key}`);
        }
      });
    }

    history.push("/");
    window.location.reload();
  }, [user, history]);

  return <div style={{ margin: "1rem auto" }}>Loading...</div>;
};

export default RccDeepLinkComponent;
